import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import TooltipWarning from '../Icons/TooltipWarning';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n\n  :after {\n    content: '';\n    ", ";\n  }\n\n  &.jui--tooltip-visible {\n    opacity: 1;\n    transform: translate(0, 0);\n    z-index: 99;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.tooltip.wrapper);
}, function (_ref2) {
  var displayIcon = _ref2.displayIcon;
  return displayIcon && 'padding-left:48px;';
}, function (_ref3) {
  var theme = _ref3.theme;
  return _extends({}, theme.tooltip.arrow);
});
export var Text = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return _extends({}, theme.tooltip.text);
});
export var WarningIcon = styled(TooltipWarning)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return _extends({}, theme.tooltip.icon);
});